/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioMensaRendicontazioneDTO } from '../model/paged-model-servizio-mensa-rendicontazione-dto';
// @ts-ignore
import { PagedModelServizioMensaRicaricaDTO } from '../model/paged-model-servizio-mensa-ricarica-dto';
// @ts-ignore
import { ServizioMensaAddPatchRicaricaForm } from '../model/servizio-mensa-add-patch-ricarica-form';
// @ts-ignore
import { ServizioMensaCalendarioMensaDTO } from '../model/servizio-mensa-calendario-mensa-dto';
// @ts-ignore
import { ServizioMensaEventoCalendarioDTO } from '../model/servizio-mensa-evento-calendario-dto';
// @ts-ignore
import { ServizioMensaEventoCalendarioForm } from '../model/servizio-mensa-evento-calendario-form';
// @ts-ignore
import { ServizioMensaRicaricaDTO } from '../model/servizio-mensa-ricarica-dto';
// @ts-ignore
import { ServizioMensaRicaricheTotaliDTO } from '../model/servizio-mensa-ricariche-totali-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    StudenteCittadinoDettaglioServiceInterface,
    AddEventoCalendarioStudenteCittadinoRequestParams,
    AddRicaricaStudenteCittadinoRequestParams,
    AvviaPagamentoStudenteCittadinoRequestParams,
    CancellaRicaricaStudenteCittadinoRequestParams,
    DownloadAvvisoStudenteCittadinoRequestParams,
    DownloadRicevutaStudenteCittadinoRequestParams,
    GetCalendarioMensaStudenteCittadinoRequestParams,
    GetTotaliRicaricheStudenteCittadinoRequestParams,
    ListEventiCalendarioStudenteCittadinoRequestParams,
    ListRendicontazioniStudenteCittadinoRequestParams,
    ListRicaricheStudenteCittadinoRequestParams,
    RemoveEventoCalendarioStudenteCittadinoRequestParams,
    VerificaRicaricaEseguitaStudenteCittadinoRequestParams
} from './studente-cittadino-dettaglio.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class StudenteCittadinoDettaglioService extends BaseService implements StudenteCittadinoDettaglioServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Aggiunge uno o più eventi calendario a un proprio studente.
     * Specchio cittadino: crea ASSENZA/PASTA_IN_BIANCO per i giorni-mensa del range. forza_evento NON è onorato (parity GENITORE): un evento data-passata/oltre-cutoff → 400. Gate Pratica-accettata + owner-check studente.
     * @endpoint post /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addEventoCalendarioStudenteCittadino(requestParameters: AddEventoCalendarioStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaEventoCalendarioDTO>>;
    public addEventoCalendarioStudenteCittadino(requestParameters: AddEventoCalendarioStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaEventoCalendarioDTO>>>;
    public addEventoCalendarioStudenteCittadino(requestParameters: AddEventoCalendarioStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaEventoCalendarioDTO>>>;
    public addEventoCalendarioStudenteCittadino(requestParameters: AddEventoCalendarioStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling addEventoCalendarioStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addEventoCalendarioStudenteCittadino.');
        }
        const servizioMensaEventoCalendarioForm = requestParameters?.servizioMensaEventoCalendarioForm;
        if (servizioMensaEventoCalendarioForm === null || servizioMensaEventoCalendarioForm === undefined) {
            throw new Error('Required parameter servizioMensaEventoCalendarioForm was null or undefined when calling addEventoCalendarioStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaEventoCalendarioDTO>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaEventoCalendarioForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una ricarica PagoPA per un proprio studente.
     * Ramo PagoPA (il cittadino non accede al ramo manuale: un comune MANUALE non espone la ricarica cittadino). Studente esente → errore; valore &lt; 0 → errore.
     * @endpoint post /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricarica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addRicaricaStudenteCittadino(requestParameters: AddRicaricaStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public addRicaricaStudenteCittadino(requestParameters: AddRicaricaStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public addRicaricaStudenteCittadino(requestParameters: AddRicaricaStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public addRicaricaStudenteCittadino(requestParameters: AddRicaricaStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling addRicaricaStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addRicaricaStudenteCittadino.');
        }
        const servizioMensaAddPatchRicaricaForm = requestParameters?.servizioMensaAddPatchRicaricaForm;
        if (servizioMensaAddPatchRicaricaForm === null || servizioMensaAddPatchRicaricaForm === undefined) {
            throw new Error('Required parameter servizioMensaAddPatchRicaricaForm was null or undefined when calling addRicaricaStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricarica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaAddPatchRicaricaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Avvia il pagamento PagoPA di una propria ricarica (URL di redirect).
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/avvia-pagamento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public avviaPagamentoStudenteCittadino(requestParameters: AvviaPagamentoStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public avviaPagamentoStudenteCittadino(requestParameters: AvviaPagamentoStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public avviaPagamentoStudenteCittadino(requestParameters: AvviaPagamentoStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public avviaPagamentoStudenteCittadino(requestParameters: AvviaPagamentoStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling avviaPagamentoStudenteCittadino.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling avviaPagamentoStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling avviaPagamentoStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_ricarica',
            <any>idRicarica,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/avvia-pagamento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Annulla una propria ricarica PagoPA non pagata.
     * Consentito solo sulle ricariche generate dal cittadino stesso (origine CITTADINO) e solo se non ancora pagate (stato IN_ATTESA_PAGAMENTO). Invoca PagoPA, porta la ricarica a CANCELLATA (soft-delete, la riga è conservata) e scollega l\&#39;eventuale rendicontazione; registra una riga audit tipizzata CITTADINO. Ricariche dell\&#39;operatore/di sistema o precedenti alla feature → non annullabili dal cittadino.
     * @endpoint delete /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public cancellaRicaricaStudenteCittadino(requestParameters: CancellaRicaricaStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public cancellaRicaricaStudenteCittadino(requestParameters: CancellaRicaricaStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public cancellaRicaricaStudenteCittadino(requestParameters: CancellaRicaricaStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public cancellaRicaricaStudenteCittadino(requestParameters: CancellaRicaricaStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling cancellaRicaricaStudenteCittadino.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling cancellaRicaricaStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling cancellaRicaricaStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/${this.configuration.encodeParam({name: "idRicarica", value: idRicarica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica l\&#39;avviso di pagamento (PDF) di una propria ricarica.
     * Fix authz §18.2.3: audience CITTADINO + owner-check (non più raggiungibile da qualunque autenticato). Avviso senza numero → errore.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/download-avviso-pagamento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadAvvisoStudenteCittadino(requestParameters: DownloadAvvisoStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadAvvisoStudenteCittadino(requestParameters: DownloadAvvisoStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadAvvisoStudenteCittadino(requestParameters: DownloadAvvisoStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadAvvisoStudenteCittadino(requestParameters: DownloadAvvisoStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling downloadAvvisoStudenteCittadino.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling downloadAvvisoStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling downloadAvvisoStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_ricarica',
            <any>idRicarica,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/download-avviso-pagamento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica la ricevuta di pagamento (PDF) di una propria ricarica.
     * Fix authz §18.2.3: audience CITTADINO + owner-check. Ricevuta senza IUV → errore.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/download-ricevuta-pagamento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadRicevutaStudenteCittadino(requestParameters: DownloadRicevutaStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadRicevutaStudenteCittadino(requestParameters: DownloadRicevutaStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadRicevutaStudenteCittadino(requestParameters: DownloadRicevutaStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadRicevutaStudenteCittadino(requestParameters: DownloadRicevutaStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling downloadRicevutaStudenteCittadino.');
        }
        const idRicarica = requestParameters?.idRicarica;
        if (idRicarica === null || idRicarica === undefined) {
            throw new Error('Required parameter idRicarica was null or undefined when calling downloadRicevutaStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling downloadRicevutaStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_ricarica',
            <any>idRicarica,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/download-ricevuta-pagamento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calendario mensa (bound + chiusure) della scuola di un proprio studente.
     * Contratto thin a supporto del date picker eventi calendario: data_inizio/data_fine (estremi inclusivi) + regole di chiusura. ASIMMETRIA load-bearing per il FE: chiusure_settimanali VINCOLA il picker (sono le sole chiusure che addEvento sottrae → un evento sull\&#39;unico giorno-weekday del range fallirebbe), mentre chiusure_puntuali è INFO-ONLY (NON blocca l\&#39;aggiunta evento: un POST evento su quella data è accettato — parity legacy). Le puntuali sono filtrate per applicabilità allo studente (scuola-intera + per-classe matchata) e ordinate. Calendario assente/date null → 404 (stessa chiave di POST evento-calendario). Gate Pratica-accettata + owner-check studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/calendario-mensa
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getCalendarioMensaStudenteCittadino(requestParameters: GetCalendarioMensaStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaCalendarioMensaDTO>;
    public getCalendarioMensaStudenteCittadino(requestParameters: GetCalendarioMensaStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaCalendarioMensaDTO>>;
    public getCalendarioMensaStudenteCittadino(requestParameters: GetCalendarioMensaStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaCalendarioMensaDTO>>;
    public getCalendarioMensaStudenteCittadino(requestParameters: GetCalendarioMensaStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getCalendarioMensaStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getCalendarioMensaStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/calendario-mensa`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaCalendarioMensaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Totale dei pagamenti di un proprio studente per anno solare.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche/totali
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTotaliRicaricheStudenteCittadino(requestParameters: GetTotaliRicaricheStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricheTotaliDTO>;
    public getTotaliRicaricheStudenteCittadino(requestParameters: GetTotaliRicaricheStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricheTotaliDTO>>;
    public getTotaliRicaricheStudenteCittadino(requestParameters: GetTotaliRicaricheStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricheTotaliDTO>>;
    public getTotaliRicaricheStudenteCittadino(requestParameters: GetTotaliRicaricheStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling getTotaliRicaricheStudenteCittadino.');
        }
        const anno = requestParameters?.anno;
        if (anno === null || anno === undefined) {
            throw new Error('Required parameter anno was null or undefined when calling getTotaliRicaricheStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getTotaliRicaricheStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'anno',
            <any>anno,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche/totali`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricheTotaliDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista degli eventi calendario personali di un proprio studente.
     * Eventi personali ordinati per data, SOLO non-CANCELLATE (la vista cittadino nasconde le cancellazioni, D-18.24). Niente chiusure scolastiche. Gate Pratica-accettata + owner-check.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listEventiCalendarioStudenteCittadino(requestParameters: ListEventiCalendarioStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaEventoCalendarioDTO>>;
    public listEventiCalendarioStudenteCittadino(requestParameters: ListEventiCalendarioStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaEventoCalendarioDTO>>>;
    public listEventiCalendarioStudenteCittadino(requestParameters: ListEventiCalendarioStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaEventoCalendarioDTO>>>;
    public listEventiCalendarioStudenteCittadino(requestParameters: ListEventiCalendarioStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listEventiCalendarioStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listEventiCalendarioStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaEventoCalendarioDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle rendicontazioni di un proprio studente.
     * Solo le rendicontazioni abilitate (le disabilitate non sono esposte al cittadino, D-18.21). Gate Pratica-accettata + owner-check studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/rendicontazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listRendicontazioniStudenteCittadino(requestParameters: ListRendicontazioniStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRendicontazioneDTO>;
    public listRendicontazioniStudenteCittadino(requestParameters: ListRendicontazioniStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRendicontazioneDTO>>;
    public listRendicontazioniStudenteCittadino(requestParameters: ListRendicontazioniStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRendicontazioneDTO>>;
    public listRendicontazioniStudenteCittadino(requestParameters: ListRendicontazioniStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listRendicontazioniStudenteCittadino.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listRendicontazioniStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listRendicontazioniStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRendicontazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle ricariche di un proprio studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricariche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listRicaricheStudenteCittadino(requestParameters: ListRicaricheStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaRicaricaDTO>;
    public listRicaricheStudenteCittadino(requestParameters: ListRicaricheStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaRicaricaDTO>>;
    public listRicaricheStudenteCittadino(requestParameters: ListRicaricheStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaRicaricaDTO>>;
    public listRicaricheStudenteCittadino(requestParameters: ListRicaricheStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listRicaricheStudenteCittadino.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listRicaricheStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listRicaricheStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricariche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaRicaricaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rimuove (cancella logicamente) un evento calendario di un proprio studente.
     * Specchio cittadino: stato&#x3D;CANCELLATO + audit. forza_evento non onorato (parity GENITORE): evento data-passata/oltre-cutoff → 400. Gate Pratica-accettata + owner-check.
     * @endpoint delete /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public removeEventoCalendarioStudenteCittadino(requestParameters: RemoveEventoCalendarioStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaEventoCalendarioDTO>;
    public removeEventoCalendarioStudenteCittadino(requestParameters: RemoveEventoCalendarioStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaEventoCalendarioDTO>>;
    public removeEventoCalendarioStudenteCittadino(requestParameters: RemoveEventoCalendarioStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaEventoCalendarioDTO>>;
    public removeEventoCalendarioStudenteCittadino(requestParameters: RemoveEventoCalendarioStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling removeEventoCalendarioStudenteCittadino.');
        }
        const idEvento = requestParameters?.idEvento;
        if (idEvento === null || idEvento === undefined) {
            throw new Error('Required parameter idEvento was null or undefined when calling removeEventoCalendarioStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling removeEventoCalendarioStudenteCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/evento-calendario/${this.configuration.encodeParam({name: "idEvento", value: idEvento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaEventoCalendarioDTO>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica una ricarica eseguita (single-IUV, accettazione-con-riserva).
     * D-18.16: se PagoPA non conferma, accetta con riserva (PAGATA + pagamento_da_verificare). La riconciliazione batch/webhook resetta il flag.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/ricarica-eseguita
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public verificaRicaricaEseguitaStudenteCittadino(requestParameters: VerificaRicaricaEseguitaStudenteCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaRicaricaDTO>;
    public verificaRicaricaEseguitaStudenteCittadino(requestParameters: VerificaRicaricaEseguitaStudenteCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaRicaricaDTO>>;
    public verificaRicaricaEseguitaStudenteCittadino(requestParameters: VerificaRicaricaEseguitaStudenteCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaRicaricaDTO>>;
    public verificaRicaricaEseguitaStudenteCittadino(requestParameters: VerificaRicaricaEseguitaStudenteCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling verificaRicaricaEseguitaStudenteCittadino.');
        }
        const iuv = requestParameters?.iuv;
        if (iuv === null || iuv === undefined) {
            throw new Error('Required parameter iuv was null or undefined when calling verificaRicaricaEseguitaStudenteCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling verificaRicaricaEseguitaStudenteCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'iuv',
            <any>iuv,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti/${this.configuration.encodeParam({name: "idStudente", value: idStudente, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricarica-eseguita`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaRicaricaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
